(function () {
  if (window.__happymamiCartSync) return;
  window.__happymamiCartSync = true;

  var cfg = window.happymamiIncluido || {};
  var incluidoTimer = null;
  var incluidoBusy = false;

  function itemBundleId(item) {
    return item && item.properties ? item.properties._bundle_id || '' : '';
  }
  function parseBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        return null;
      }
    }
    return null;
  }
  function requestUrl(input) {
    if (typeof input === 'string') return input;
    return input && input.url ? input.url : '';
  }
  function headerFlag(headers, name) {
    if (!headers) return false;
    if (headers.get && headers.get(name)) return true;
    return !!headers[name];
  }
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }
  function isGift(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (props._hm_incluido) return true;
    if (cfg.variantId && (Number(item.variant_id) === Number(cfg.variantId) || Number(item.id) === Number(cfg.variantId))) {
      return true;
    }
    if (cfg.productId && Number(item.product_id) === Number(cfg.productId)) return true;
    return normalizeText(item.product_title).indexOf('incluido con tu biber') !== -1;
  }
  function isBottle(item) {
    if (!item || isGift(item)) return false;
    var props = item.properties || {};
    if (props._tipo === 'vaso') return true;
    if (cfg.bottleProductId && Number(item.product_id) === Number(cfg.bottleProductId)) return true;
    var handle = normalizeText(item.handle);
    var title = normalizeText(item.product_title);
    if (handle.indexOf('biberon') !== -1) return true;
    if (title.indexOf('biberon personalizado') !== -1) return true;
    return false;
  }
  function cartJsonUrl() {
    return (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
  }
  function cartAddUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return /\.js(\?|$)/.test(base) ? base : base + '.js';
  }
  function cartUpdateUrl() {
    var updateBase = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return /\.js(\?|$)/.test(updateBase) ? updateBase : updateBase + '.js';
  }
  function cartChangeUrl() {
    var changeBase = (window.routes && window.routes.cart_change_url) || '/cart/change';
    return /\.js(\?|$)/.test(changeBase) ? changeBase : changeBase + '.js';
  }
  function cartUi() {
    return document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  }
  function sectionsPayload() {
    var cart = cartUi();
    var payload = {};
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (section) {
          return section.section || section.id;
        })
        .filter(Boolean);
      payload.sections_url = window.location.pathname;
    }
    return payload;
  }
  function markCartEmpty(itemCount) {
    if (typeof itemCount !== 'number') return;
    var empty = itemCount === 0;
    var cart = cartUi();
    if (cart) cart.classList.toggle('is-empty', empty);
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', empty);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
  }
  function renderCart(data) {
    if (data) markCartEmpty(data.item_count);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && data && data.sections && data.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(data);
      } catch (e) {}
    }
    if (window.publish && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'happymami-incluido', cartData: data });
    }
  }
  function jsonFetch(url, options) {
    return nativeFetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error((data && data.description) || 'Cart error');
        }
        return data;
      });
    });
  }

  function syncIncluido() {
    var variantId = Number(cfg.variantId || 0);
    if (!variantId) return;
    if (incluidoBusy) {
      scheduleIncluido();
      return;
    }
    incluidoBusy = true;
    nativeFetch(cartJsonUrl(), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var hasBottle = items.some(isBottle);
        var gifts = items.filter(isGift);
        var extraUpdates = {};
        gifts.forEach(function (item, index) {
          if (index === 0 && hasBottle && Number(item.quantity) === 1) return;
          extraUpdates[item.key] = index === 0 && hasBottle ? 1 : 0;
        });
        if (!hasBottle) {
          if (!gifts.length) return null;
          var clear = { updates: extraUpdates };
          Object.assign(clear, sectionsPayload());
          return jsonFetch(cartUpdateUrl(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Happymami-Incluido': '1',
            },
            credentials: 'same-origin',
            body: JSON.stringify(clear),
          });
        }
        if (gifts.length && Object.keys(extraUpdates).length) {
          var clamp = { updates: extraUpdates };
          Object.assign(clamp, sectionsPayload());
          return jsonFetch(cartUpdateUrl(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Happymami-Incluido': '1',
            },
            credentials: 'same-origin',
            body: JSON.stringify(clamp),
          });
        }
        if (gifts.length) return null;
        var addBody = {
          items: [{ id: variantId, quantity: 1, properties: { _hm_incluido: '1' } }],
        };
        Object.assign(addBody, sectionsPayload());
        return jsonFetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Happymami-Incluido': '1',
          },
          credentials: 'same-origin',
          body: JSON.stringify(addBody),
        });
      })
      .then(function (data) {
        if (data) renderCart(data);
      })
      .catch(function () {})
      .then(function () {
        incluidoBusy = false;
      });
  }

  function scheduleIncluido() {
    if (!Number(cfg.variantId || 0)) return;
    clearTimeout(incluidoTimer);
    incluidoTimer = setTimeout(syncIncluido, 200);
  }

  var nativeFetch = window.fetch.bind(window);

  function stripHmBundle() {
    return nativeFetch(cartJsonUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var dirty = (cart.items || []).filter(function (item) {
          return item && item.properties && item.properties.HmBundle;
        });
        return dirty.reduce(function (chain, item) {
          return chain.then(function () {
            var props = {};
            Object.keys(item.properties).forEach(function (key) {
              if (key === 'HmBundle') return;
              if (item.properties[key] == null || item.properties[key] === '') return;
              props[key] = item.properties[key];
            });
            return nativeFetch(cartChangeUrl(), {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                properties: props,
              }),
            });
          });
        }, Promise.resolve());
      })
      .catch(function () {});
  }

  var hmBundleStrip = stripHmBundle();

  document.addEventListener(
    'click',
    function (event) {
      var node = event.target;
      if (!node || !node.closest) return;
      var checkout = node.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
      if (!checkout || checkout.dataset.hmBundleReady === '1') return;
      event.preventDefault();
      event.stopPropagation();
      hmBundleStrip.then(function () {
        checkout.dataset.hmBundleReady = '1';
        checkout.click();
      });
    },
    true
  );

  window.fetch = function (input, init) {
    var url = requestUrl(input);
    var headers = init && init.headers;
    var incluidoReq = headerFlag(headers, 'X-Happymami-Incluido');
    var bundleReq = headerFlag(headers, 'X-Happymami-Bundle');
    var isCartMut = /\/cart\/(add|change|update|clear)/.test(url);

    var request = nativeFetch;
    if (/\/cart\/(change|update)/.test(url) && !bundleReq && !incluidoReq) {
      request = function (innerInput, innerInit) {
        var body = parseBody(innerInit && innerInit.body);
        if (!body) return nativeFetch(innerInput, innerInit);
        var wantsZero = Number(body.quantity) === 0;
        if (!wantsZero && body.updates) {
          wantsZero = Object.keys(body.updates).some(function (key) {
            return Number(body.updates[key]) === 0;
          });
        }
        if (!wantsZero) return nativeFetch(innerInput, innerInit);

        return nativeFetch(cartJsonUrl(), { headers: { Accept: 'application/json' } })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            var targets = [];
            if (body.line) targets.push(cart.items[Number(body.line) - 1]);
            if (body.id) {
              var wanted = String(body.id);
              cart.items.forEach(function (item) {
                if (item.key === wanted || String(item.variant_id) === wanted || String(item.id) === wanted) {
                  targets.push(item);
                }
              });
            }
            if (body.updates) {
              Object.keys(body.updates).forEach(function (key) {
                if (Number(body.updates[key]) !== 0) return;
                cart.items.forEach(function (item) {
                  if (item.key === key) targets.push(item);
                });
              });
            }
            var bundleIds = {};
            targets.forEach(function (item) {
              var bid = itemBundleId(item);
              if (bid) bundleIds[bid] = true;
            });
            var updates = {};
            cart.items.forEach(function (item) {
              if (!item) return;
              var targeted = targets.indexOf(item) !== -1;
              if (targeted || (itemBundleId(item) && bundleIds[itemBundleId(item)])) {
                updates[item.key] = 0;
              }
            });
            var bottlesLeft = cart.items.some(function (item) {
              return !Object.prototype.hasOwnProperty.call(updates, item.key) && isBottle(item);
            });
            if (!bottlesLeft) {
              cart.items.forEach(function (item) {
                if (isGift(item)) updates[item.key] = 0;
              });
            }
            var originalZeros = 1;
            if (body.updates) {
              originalZeros = Object.keys(body.updates).filter(function (key) {
                return Number(body.updates[key]) === 0;
              }).length;
            }
            if (Object.keys(updates).length <= originalZeros && bottlesLeft) {
              return nativeFetch(innerInput, innerInit);
            }
            var payload = { updates: updates };
            if (body.sections) payload.sections = body.sections;
            if (body.sections_url) payload.sections_url = body.sections_url;
            return nativeFetch(cartUpdateUrl(), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Happymami-Bundle': '1',
              },
              credentials: 'same-origin',
              body: JSON.stringify(payload),
            });
          })
          .catch(function () {
            return nativeFetch(innerInput, innerInit);
          });
      };
    }

    function send(sendInput, sendInit) {
      return request(sendInput, sendInit).then(function (response) {
        if (isCartMut && !incluidoReq) scheduleIncluido();
        return response;
      });
    }

    // El producto incluido viaja en la MISMA petición que el biberón: una sola alta en el carrito, que es
    // lo que ven Klaviyo y los píxeles (antes salía una segunda alta solo con el regalo).
    if (/\/cart\/add/.test(url) && !incluidoReq && Number(cfg.variantId || 0)) {
      var addBody = parseBody(init && init.body);
      var addItems = addBody && Array.isArray(addBody.items) ? addBody.items : null;
      var withBottle =
        addItems &&
        addItems.some(function (line) {
          return line && line.properties && line.properties._tipo === 'vaso';
        });
      var withGift =
        addItems &&
        addItems.some(function (line) {
          return line && line.properties && line.properties._hm_incluido;
        });
      if (withBottle && !withGift) {
        return nativeFetch(cartJsonUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            if ((cart.items || []).some(isGift)) return send(input, init);
            var body = JSON.parse(JSON.stringify(addBody));
            body.items.push({ id: Number(cfg.variantId), quantity: 1, properties: { _hm_incluido: '1' } });
            var withGiftInit = Object.assign({}, init, { body: JSON.stringify(body) });
            return send(input, withGiftInit).then(function (response) {
              // Si el regalo no se puede añadir (sin stock…), el biberón se añade igualmente como antes.
              return response.ok ? response : send(input, init);
            });
          })
          .catch(function () {
            return send(input, init);
          });
      }
    }

    return send(input, init);
  };

  function adminBarEl() {
    return (
      document.getElementById('preview-bar-iframe') ||
      document.querySelector('iframe.preview-bar-iframe') ||
      document.querySelector('iframe[id*="preview-bar"]') ||
      document.querySelector('iframe[src*="preview_bar"]')
    );
  }

  function setAdminOffset() {
    var bar = adminBarEl();
    var height = 0;
    if (bar) {
      if (!bar.__hmOffsetBound) {
        bar.__hmOffsetBound = true;
        bar.addEventListener('load', scheduleAdminOffset);
      }
      height = Math.round(bar.getBoundingClientRect().height || bar.offsetHeight || 0);
      if (height < 24) height = 56;
    }
    document.documentElement.style.setProperty('--hm-admin-offset', height + 'px');
  }

  var adminTimer = null;
  function scheduleAdminOffset() {
    clearTimeout(adminTimer);
    adminTimer = setTimeout(setAdminOffset, 50);
  }

  setAdminOffset();
  window.addEventListener('resize', scheduleAdminOffset);
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(scheduleAdminOffset).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleIncluido();
      setAdminOffset();
    });
  } else {
    scheduleIncluido();
  }
})();
